import AbstractAPI from '@/services/api/AbstractAPI';

export default class PaymentsAPI extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/payments');
  }

  getPaymentMethods() {
    return this.makeRequest('/inventory', 'get');
  }

  delete(id) {
    return this.makeRequest(`/delete/${id}`, 'delete');
  }

  createSetupIntent() {
    return this.makeRequest('/create-setup-intent', 'get');
  }

  createPaymentIntent(paymentMethod, invoices) {
    return this.makeRequest('/create-payment-intent', 'post', {paymentMethod, invoices});
  }

  saveCard(setup_intent_id, is_default) {
    return this.makeRequest('/save-card', 'post', {setup_intent_id, is_default});
  }

  setAutoPay(enableAutoPay) {
    return this.makeRequest('/set-auto-pay', 'post', {enableAutoPay});
  }

  setDefault(paymentMethod) {
    return this.makeRequest(`/update/${paymentMethod}`, 'put');
  }
}
